/**
* Transactions List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Transactions List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'transactions-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.transactions-list' ).each( function() {
        let categoryValue = $( this ).find( '#category-select' ).val();
        let tagsValue = $( this ).find( '#tags-select' ).val();
        $( this ).find( '#category-select' ).on( 'change', function() {
          categoryValue = $( this ).val();
        } );
        $( this ).find( '#tags-select' ).on( 'change', function() {
          tagsValue = $( this ).val();
        } );
        $( this ).find( '#view-results' ).on( 'click', function() {
          $.ajax( {
            type: 'GET',
            url: `${siteInfo.wpApiSettings.ll}loadfilter`,
            dataType: 'json',
            data: {
              category: categoryValue,
              tags: tagsValue,
            },
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( res ) {
              if ( res.html === null ) {
                return 0;
              } else {
                $( '#list-transactions' ).html( res.html );
              }
            },
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'transactions-list', COMPONENT );
} )( app );
